var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 753.66 510.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-hair-1 {\n        fill: var(--custom-color, #62210b) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M701.44,335.88l35,175s41.29-135.98-4-285C686.4,74.4,547.76,6.92,392.82.54c-.24-.01-.47-.03-.71-.04C225.2-6.49,71.53,59.33,22.44,220.88c-45.29,149.02-8,281-8,281l37-168c20.56,14.55,64.07-16.52,85-46,13.33-18.78,13.84-57.85,13.21-78.68,23.83,50.33,117.12,87.89,228.59,87.89s196.67-34.39,225.11-81.45c.71,19.38,2.1,60.37,14.09,77.25,20.93,29.48,63.44,57.55,84,43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair1);
export default __webpack_public_path__ + "static/media/hair1.73ad19ae48f7fe06b640cd4eda2ffc75.svg";
export { ForwardRef as ReactComponent };